import React from "react";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";

// Coexistência: o número da Cloud API continua no app WhatsApp Business do
// celular. Mostra a importação única de contatos e histórico
// (Whatsapps.cloudApiCoexistenceSync, gravado pelo backend) e o lembrete de
// abrir o app — a Meta desconecta o número após 14 dias sem uso.

// Prazo da Meta para pedir a sincronização depois do cadastro.
const SYNC_WINDOW_MS = 24 * 60 * 60 * 1000;
const PHASES = ["0", "1", "2"];

const parseSync = (raw) => {
  if (!raw) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) || {};
    } catch {
      return {};
    }
  }
  return raw;
};

const t = (key, params) => i18n.t(`whatsappModal.cloudApi.coexistence.status.${key}`, params);

// Pedido ainda sem conteúdo: esperando a Meta, falhou, ou nem foi feito.
const requestState = (request, windowOver) => {
  if (request?.requestId) return t("waiting");
  if (windowOver) return t("expired");
  if (request?.error) return t("failed", { error: request.error });
  return t("notRequested");
};

const CoexistenceStatus = ({ whatsApp, className }) => {
  const sync = parseSync(whatsApp?.cloudApiCoexistenceSync);
  const onboardedAt = Date.parse(sync.onboardedAt || "");
  const windowOver = Boolean(onboardedAt) && Date.now() - onboardedAt > SYNC_WINDOW_MS;

  const contacts = sync.contacts || {};
  const contactsText = contacts.received
    ? t("contactsReceived", { count: contacts.received })
    : requestState(contacts, windowOver);

  const history = sync.history || {};
  const phases = history.phases || {};
  const hasProgress = PHASES.some((phase) => phases[phase] !== undefined);
  const percent = Math.round(
    PHASES.reduce((sum, phase) => sum + (Number(phases[phase]) || 0), 0) / PHASES.length
  );
  const historyText = history.declined
    ? t("historyDeclined")
    : history.finishedAt
    ? t("historyDone", { count: history.imported || 0 })
    : hasProgress
    ? t("historyImporting", { percent, count: history.imported || 0 })
    : requestState(history, windowOver);

  const disconnected = whatsApp?.status === "DISCONNECTED";

  return (
    <Box mt={2} p={1} borderRadius={4} className={className}>
      <Typography variant="body2">
        <strong>{t("title")}</strong>
        <br />
        {t("inactivityReminder")}
        <br />
        <strong>{t("contactsLabel")}</strong> {contactsText}
        <br />
        <strong>{t("historyLabel")}</strong> {historyText}
        {disconnected && whatsApp?.cloudApiSubscriptionLastError && (
          <>
            <br />
            <strong>{t("disconnectedLabel")}</strong> {whatsApp.cloudApiSubscriptionLastError}
          </>
        )}
      </Typography>
    </Box>
  );
};

export default CoexistenceStatus;
